import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="bg-paper px-4 pb-6 sm:pb-8" data-id="element-64" data-mp="1o3x1pk7r0m0y">
      <div className="mx-auto flex max-w-3xl items-start gap-3 rounded-xl border border-auto/30 bg-white p-4" data-id="element-65" data-mp="1o3dnoel7yhs7">
        <ShieldCheckIcon className="h-10 w-10 shrink-0 text-auto" aria-hidden="true" data-id="element-66" data-mp="221bw73cuzjzs" />
        <div data-id="element-67" data-mp="19eqw9eibhzkm">
          <h2 className="text-xl text-navy sm:text-2xl" data-id="element-68" data-mp="19ehe2d3ikwph">
            YOUR PURCHASE IS 100% PROTECTED
          </h2>
          <p className="mt-1 text-sm font-medium leading-snug text-ink/80" data-id="element-69" data-mp="14gfod9bl1z51">
            Explore AUTOMOTIVE DIAGNOSTIC PRO™ for 7 days. Access the complete
            6-module diagnostic system and all 5 professional bonuses. If it
            isn&apos;t right for you, contact us within 7 days for a full refund
            according to the refund terms.
          </p>
        </div>
      </div>
    </section>;
}